import './lib/_jquery.ajaxchimp.js';
import './lib/_cookie.js';
import './lib/jquery.tubular.1.0.js';
import './functions/_cta.js';
import './functions/_newsletter.js';
import './functions/_adblock.js';
import './functions/_user-status.js';
import './functions/_popup.js';
import './functions/_screenings.js';
import './functions/_article.js';
import './functions/_most-popular.js';


b247.newsletter();
b247.adblock();
//b247.user_status(); // sign in stuff
b247.cta();
b247.popup.init();
b247.screenings();
b247.article();
b247.most_popular();

$(document).ready(function() {
	
	var $video_header = $("#video-header");
	if($video_header.length>0) {				
		var start 	= $video_header.attr("data-start"),
			end 	= $video_header.attr("data-end"),
			id 		= $video_header.attr("data-id");									
		$video_header.tubular({videoId: id, start: parseInt(start), end: parseInt(end)});
	}	
	
	
	// For desktop we need to watch the mpu adverts for when they load in and if they have loaded in a tall ad then add a class to the wrapper to force it to always be large when the user rediuces screenn size to small
	
	var mpu_to = setInterval(function(){		
		var $mpus = $(".mpu:not(.has_loaded)");
		if($mpus.length>0) {
			$mpus.each(function(){
				var $this = $(this);
				if($this.has("iframe")) {
					var h = $this.find("iframe").height();				
					if(h > 250) {
						$this.addClass("has_loaded--tall");
						$("html").addClass("has_loaded--tall-advert");
					}
					$this.addClass("has_loaded");
				}
			});
		} else {
			clearInterval(mpu_to);
		}
		
		
	},50);
	
	
	// Redirect performances to listings pages
	var perf_redirect = $("[data-performance-to-listing]");
	if( perf_redirect.length > 0 ) {
		var u = perf_redirect.attr("data-performance-to-listing")
		window.location = u;
	}
	
	$.ajax({
		url: ajax_url,
		method: "POST",
		data: {
			'action' : 'check_member_cookie'
		},
	});
});

